import clsx from 'clsx';

import '../scss/Select.scss';

function Select({
  name,
  value,
  className,
  options,
  onChange,
  border,
  borderRadius,
  backgroundColor,
  readOnly = false,
}) {
  return (
    <div className={clsx('ui-select', className)}>
      <select
        name={name}
        className="ui-select__input"
        onChange={onChange}
        value={value}
        disabled={readOnly}
        style={{ border: `${border}`, borderRadius: `${borderRadius}`, backgroundColor: `${backgroundColor}` }}
      >
        <option value="" disabled selected={value == null}>Select</option>
        {options && options.map((o) => (
          <option disabled={o.isDisabled} value={o.value}>
            {o.name}
          </option>
        ))}
      </select>
      <ion-icon class="ui-select__arrow" name="caret-down-outline" />
    </div>
  );
}

export default Select;

// export function PlainSelect({
//   name,
//   value,
//   options,
//   onChange,
// }) {
//   return (
//     <select
//       className="ui-plain-select"
//       name={name}
//       onChange={onChange}
//       value={value}
//     >
//       <option value="" disabled selected={value == null}>Select</option>
//       {options && options.map((o) => (
//         <option disabled={o.isDisabled} value={o.value}>
//           {o.name}
//         </option>
//       ))}
//     </select>
//   );
// }
